import { ChoiceCardOption } from "@/components/campos-formulario/novos/ChoiceCards";
import { NIVEL_CONFIG, NIVEL_COMPORTAMENTO } from "@/components/comunicados/comunicado-nivel";
import { ComunicadoSistemaNivel } from "@/types/comunicado-sistema.type";

/**
 * Cartões de nível (decisão conceitual, doc §4.1). O cartão descreve a
 * consequência — onde aparece e se cobra aceite —, não a cor: é a informação de
 * que o admin precisa para escolher.
 */
export const NIVEL_CHOICE_OPTIONS: ChoiceCardOption<ComunicadoSistemaNivel>[] = (
  ["INFORMATIVO", "ALERTA", "CRITICO"] as ComunicadoSistemaNivel[]
).map((nivel) => {
  const { label, Icon, dot } = NIVEL_CONFIG[nivel];
  const { quando, barra, aceite } = NIVEL_COMPORTAMENTO[nivel];

  return {
    value: nivel,
    title: label,
    description: (
      <span className="flex flex-col gap-1">
        <span>{quando}</span>
        <span className="flex items-start gap-1.5">
          <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${dot}`} />
          {barra}
        </span>
        <span className="flex items-start gap-1.5">
          <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${dot}`} />
          {aceite}
        </span>
      </span>
    ),
    icon: <Icon className="size-5" />,
  };
});
